exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-tag + .el-tag[data-v-c7385d2a] {\r\n  margin-left: 10px;\n}\n.button-new-tag[data-v-c7385d2a] {\r\n  margin-left: 10px;\r\n  height: 32px;\r\n  line-height: 30px;\r\n  padding-top: 0;\r\n  padding-bottom: 0;\r\n  color: #999;\n}\n.input-new-tag[data-v-c7385d2a] {\r\n  width: 90px;\r\n  margin-left: 10px;\r\n  vertical-align: bottom;\n}\r\n", ""]);

// exports
